const watchHistoryConfig = {
  completedThreshold: 95, // %
  noDurationPercentCompleted: 80,
  continueWatching: {
    batchSize: 10,
  },
}

export default watchHistoryConfig
